import { ForgotPassword } from "@/components/auth/ForgotPassword";

const ForgotPasswordPage = () => {
  return (
    <>
      <ForgotPassword />
    </>
  );
};

export { ForgotPasswordPage };
